import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ページ遷移時のスクロール位置を制御するコンポーネント
 * すべてのページ遷移時にスクロール位置をトップにリセットします。
 * これにより、ユーザーは常にページの上部から内容を確認できます。
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // main要素のスクロールをリセット（main要素がスクロールコンテナ）
    const mainElement = document.querySelector('main');
    if (mainElement) {
      mainElement.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
      });
    }

    // より確実にするため、少し遅延してもう一度実行
    const timer = setTimeout(() => {
      if (mainElement) {
        mainElement.scrollTop = 0;
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
